import React, { useState, useEffect, useCallback } from "react";

import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { isAfter, parse, isValid, format, isEqual } from "date-fns";

import {
  Permission,
  referenciaFunc,
} from "../../../../../../helpers/Funcionalidades";

import {
  Flex,
  SimpleGrid,
  Grid,
  GridItem,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Divider,
  Text,
} from "@chakra-ui/react";

import {
  telefone as telMask,
  cpf,
  cep as cepMask,
  numeroEndereco,
  onlyNumbers,
  forNames,
} from "../../../../../utils/masks";
import { useAuthProvider } from "../../../../../../Context/AuthProvider";

import { CustomButton } from "../../../../../components/CustomButton";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import { CustomSelectWField } from "../../../../../components/CustomSelectWField";
import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";
import { FocusError } from "../../../../../components/FocusError";
import CriancaService from "../../../../../../main/services/CriancaService";
import DadosGeograficosService from "../../../../../../main/services/DadosGeograficosService";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import { CustomTextArea } from "../../../../../components/CustomTextArea";
import { isValidCPF } from "../../../../../utils/isValidCPF";

export const IrmaosEditar = ({
  isOpen,
  onOpen,
  onClose,
  filiacoes,
  setFieldValue,
  selectedFiliacao,
  updateFromVisualizacao,
  dataNascimentoCA,
  isVisualizacao,
  secondOnClose,
  idCrianca,
  fetchIrmaosData,
  dataIrmaos,
  idPJ,
}) => {
  const [isVisual, setIsVisual] = useState(!!isVisualizacao);
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);
  const [bairros, setBairros] = useState({ options: [], isLoading: false });
  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });
  const { setEditarIrmao, editarIrmao } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const [estados, setEstados] = useState({ options: [], isLoading: false });
  const [estado, setEstado] = useState();
  const [municipio, setMunicipio] = useState();
  const [opcoesFiliacao, setOpcoesFiliacao] = useState([]);
  const [dataFutura, setDataFutura] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [invalidCPF, setInvalidCPF] = useState(false);
  const [criancaCPFValid, setCriancaCPFValid] = useState(false);
  const [initialValues, setInitialValues] = useState({
    situacao: "",
    filiacao: "",
    servicoAcolhimento: "",
    nome: "",
    cep: "",
    complemento: "",
    cpf: "",
    email: "",
    dataNascimento: "",
    id: "",
    idBairro: "",
    idEstado: "",
    idMunicipio: "",
    informacoesComplementares: "",
    logradouro: "",
    numeroIdentidade: "",
    numeroResidencia: "",
    pontoReferencia: "",
    telefone: "",
  });

  useEffect(() => {
    setMunicipios((prevState) => ({ ...prevState, isLoading: true }));
    if (estado) {
      DadosGeograficosService.pesquisarMunicipios(estado.id).then((res) => {
        setMunicipios({ options: res.data, isLoading: false });
      });
    } else {
      setMunicipios({ options: [], isLoading: false });
    }
  }, [estado]);

  useEffect(() => {
    setBairros((prevState) => ({ ...prevState, isLoading: true }));
    if (municipio) {
      DadosGeograficosService.pesquisarBairros(municipio.id).then((res) => {
        setBairros({ options: res.data, isLoading: false });
      });
    } else {
      setBairros({ options: [], isLoading: false });
    }
  }, [municipio]);

  const handleGetEstados = useCallback(() => {
    setEstados((prevState) => ({ ...prevState, isLoading: true }));

    DadosGeograficosService.getEstados().then((res) => {
      setEstados({ options: res.data, isLoading: false });
    });
  }, []);

  const backAlert = () => {
    if (editarIrmao) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setEditarIrmao(false);
        }
      });
    } else {
      onClose();
    }
  };

  useEffect(() => {
    const {
      pessoaFisicaIrmao,
      situacao,
      servicoAcolhimento,
      filiacoes,
      idBairro,
      bairro,
      idEstado,
      estado,
      idMunicipio,
      municipio,
      ...resto
    } = selectedFiliacao;

    const filiacaoModificado = filiacoes.map((item) => ({
      id: item?.id,
      idTipoRelacionamento: item?.idTipoRelacionamento,
      nome: item?.nome,
    }));

    setInitialValues({
      filiacao: filiacoes ? [filiacaoModificado] : "",
      nome: pessoaFisicaIrmao.nome ? pessoaFisicaIrmao.nome : "",
      cep: pessoaFisicaIrmao.cep ? cepMask(pessoaFisicaIrmao.cep) : "",
      complemento: pessoaFisicaIrmao.complemento
        ? pessoaFisicaIrmao.complemento
        : "",
      cpf: pessoaFisicaIrmao.cpf ? cpf(pessoaFisicaIrmao.cpf) : "",
      dataNascimento: pessoaFisicaIrmao.dataNascimento
        ? isValid(pessoaFisicaIrmao.dataNascimento)
          ? format(new Date(pessoaFisicaIrmao.dataNascimento), "dd/MM/yyyy")
          : pessoaFisicaIrmao.dataNascimento
        : "",
      email: pessoaFisicaIrmao.email ? pessoaFisicaIrmao.email : "",
      idBairro: pessoaFisicaIrmao.bairro
        ? pessoaFisicaIrmao.bairro
        : pessoaFisicaIrmao.idBairro
        ? pessoaFisicaIrmao.idBairro
        : "",
      idEstado: pessoaFisicaIrmao.estado
        ? pessoaFisicaIrmao.estado
        : pessoaFisicaIrmao.idEstado
        ? pessoaFisicaIrmao.idEstado
        : "",
      idMunicipio: pessoaFisicaIrmao.municipio
        ? pessoaFisicaIrmao.municipio
        : pessoaFisicaIrmao.idMunicipio
        ? pessoaFisicaIrmao.idMunicipio
        : "",
      informacoesComplementares: pessoaFisicaIrmao.informacoesComplementares
        ? pessoaFisicaIrmao.informacoesComplementares
        : "",
      logradouro:
        pessoaFisicaIrmao.logradouro && pessoaFisicaIrmao.logradouro === "-"
          ? ""
          : pessoaFisicaIrmao.logradouro
          ? pessoaFisicaIrmao.logradouro
          : "",
      numeroIdentidade: pessoaFisicaIrmao.numeroIdentidade
        ? pessoaFisicaIrmao.numeroIdentidade
        : "",
      numeroResidencia: pessoaFisicaIrmao.numeroResidencia
        ? pessoaFisicaIrmao.numeroResidencia
        : "",
      pontoReferencia: pessoaFisicaIrmao.pontoReferencia
        ? pessoaFisicaIrmao.pontoReferencia
        : "",

      telefone: pessoaFisicaIrmao.telefone ? pessoaFisicaIrmao.telefone : "",
      situacao: situacao ? situacao : "",
      servicoAcolhimento: servicoAcolhimento ? servicoAcolhimento : "",
      ...resto,
    });

    if (pessoaFisicaIrmao.estado) {
      setEstado(pessoaFisicaIrmao.estado);
    } else if (idEstado) {
      setEstado(idEstado);
    }
    if (pessoaFisicaIrmao.municipio) {
      setMunicipio(pessoaFisicaIrmao.municipio);
    } else if (idMunicipio) {
      setMunicipio(idMunicipio);
    }
    if (pessoaFisicaIrmao.bairro) {
      setBairros(pessoaFisicaIrmao.bairro);
    } else if (idBairro) {
      setBairros(idBairro);
    }
  }, [selectedFiliacao]);

  useEffect(() => {
    setOpcoesFiliacao("");
  }, []);

  const schema = Yup.object().shape(
    {
      filiacao: Yup.array().required("Este campo é obrigatório!"),
      cep: Yup.string(),
      complemento: Yup.string(),
      cpf: Yup.string()
        .nullable()
        .test("cpfValido", "", (value) => {
          if (!isValidCPF(value)) {
            return false;
          } else {
            return true;
          }
        })
        .test("unicidade", "", (value) => {
          if (
            criancaCPFValid &&
            value?.replace(/[.-]|[.-](?=.)/g, "").trim() !==
              selectedFiliacao?.pessoaFisicaIrmao?.cpf
          ) {
            return false;
          } else {
            return true;
          }
        }),
      email: Yup.string().trim().email("Email inválido!"),
      dataNascimento: Yup.string()
        .nullable()
        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return true;
          }
        })
        .test(
          "dataNascimentoAfterToday",
          "A data informada não pode ser uma data futura!",
          (value) => {
            if (!value) {
              return true;
            } else {
              return !isAfter(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date()
              );
            }
          }
        )
        .test(
          "dataNascimentoAfter",
          "A data informada não pode ser posterior ao nascimento da criança/adolescente!",
          (value) => {
            if (updateFromVisualizacao && !!dataNascimentoCA) {
              return !isAfter(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date(dataNascimentoCA)
              );
            } else {
              return true;
            }
          }
        )
        .test(
          "dataNascimentoEqual",
          "A data informada não pode ser igual à data de nascimento da criança/adolescente!",
          (value) => {
            if (updateFromVisualizacao && !!dataNascimentoCA) {
              return !isEqual(
                parse(value, "dd/MM/yyyy", new Date()),
                new Date(dataNascimentoCA)
              );
            } else {
              return true;
            }
          }
        ),
      falecido: Yup.array(),
      id: Yup.string(),
      idBairro: Yup.mixed().when("idMunicipio", {
        is: (municipio) =>
          municipio ? municipio.id === 3233 || municipio.id === 3215 : false,
        then: Yup.mixed().required("Este campo é obrigatório!").nullable(),
      }),
      idEstado: Yup.mixed(),
      idMunicipio: Yup.mixed(),
      informacoesComplementares: Yup.string(),
      logradouro: Yup.string(),
      nome: Yup.string()
        .required("Este campo é obrigatório!")
        .trim("Este campo é obrigatório!")
        .when("cpf", {
          is: (cpf) => !!cpf,
          then: (schemaOuter) => {
            return schemaOuter.when("cpf", ([cpf], schema) => {
              return schema.test("unicidade", "Nome já cadastrado", (value) => {
                if (value) {
                  const found = filiacoes
                    .filter((filiacao) => filiacao.id !== selectedFiliacao.id)
                    .find((filiacao) => {
                      if (filiacao.cpf) {
                        return (
                          filiacao.nome.toUpperCase() + filiacao.cpf ===
                          value.toUpperCase() + cpf
                        );
                      } else {
                        if (!!filiacao.nome && !!value) {
                          return (
                            filiacao.nome.toUpperCase() ===
                            value.toUpperCase() + cpf
                          );
                        } else {
                          return false;
                        }
                      }
                    });
                  if (!!found) {
                    return false;
                  } else {
                    return true;
                  }
                } else {
                  return true;
                }
              });
            });
          },
          otherwise: (schema) => {
            return schema.test("unicidade", "Nome já cadastrado", (value) => {
              if (value) {
                const found = filiacoes
                  .filter((filiacao) => filiacao.id !== selectedFiliacao.id)
                  .find((filiacao) => {
                    if (filiacao.cpf) {
                      return (
                        filiacao.nome.toUpperCase() + filiacao.cpf ===
                        value.toUpperCase()
                      );
                    } else {
                      return (
                        filiacao.nome.toUpperCase() === value.toUpperCase()
                      );
                    }
                  });
                if (!!found) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            });
          },
        })
        .test("unicidade", "Nome já cadastrado para esta criança", (value) => {
          if (value) {
            const found = filiacoes
              .filter((filiacao) => filiacao.id !== selectedFiliacao.id)
              .find((filiacao) => {
                return filiacao.nome.toUpperCase() === value.toUpperCase();
              });
            if (!!found) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }),
      numeroIdentidade: Yup.string(),
      numeroResidencia: Yup.number(),
      pontoReferencia: Yup.string(),
      status: Yup.string(),
      telefone: Yup.string()
        .min(14, "Telefone inválido!")
        .max(15, "Telefone inválido!"),
    },
    [
      ["cpf", "nome"],
      ["nome", "cpf"],
    ]
  );

  const handleGetFiliacao = (id) => {
    setOpcoesFiliacao({ ...opcoesFiliacao, isLoading: true });
    CriancaService.getFiliacao(id).then((res) => {
      setOpcoesFiliacao({
        options: res.data,
        isLoading: false,
      });
    });
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        filiacao,
        servicoAcolhimento,
        nome,
        dataNascimento,
        cpf,
        numeroIdentidade,
        email,
        informacoesComplementares,
        idEstado,
        idMunicipio,
        idBairro,
        logradouro,
        complemento,
        pontoReferencia,
        numeroResidencia,
        telefone,
        cep,
      } = values;

      const valuesToSend = {
        nome: nome ? nome.trim() : "",
        dataNascimento: dataNascimento
          ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        cpf: cpf ? cpf.trim() : "",
        numeroIdentidade: numeroIdentidade ? numeroIdentidade.trim() : "",
        email: email ? email?.trim() : "",
        informacoesComplementares: informacoesComplementares
          ? informacoesComplementares?.trim()
          : "",
        id: 0,
        idEstado: idEstado ? idEstado.id : "",
        idMunicipio: idMunicipio ? idMunicipio.id : "",
        idBairro: idBairro ? idBairro.id : "",
        logradouro: logradouro ? logradouro?.trim() : "",
        complemento: complemento ? complemento?.trim() : "",
        pontoReferencia: pontoReferencia ? pontoReferencia?.trim() : "",
        filiacao: filiacao ? filiacao[0] : "",
        servicoAcolhimento: servicoAcolhimento ? servicoAcolhimento : "",
        cep: cep,
        numeroResidencia: numeroResidencia,
        telefone: telefone,
      };

      if (updateFromVisualizacao) {
        if (selectedFiliacao?.situacao === "Desligado") {
          CriancaService.putEnderecoIrmao(
            idCrianca,
            selectedFiliacao.pessoaFisicaIrmao.idPessoaFisica,
            valuesToSend
          )
            .then((res) => {
              onClose();
              fetchIrmaosData();
              Swal.fire({
                title: "Sucesso!",
                text: "Registro atualizado com sucesso!",
                icon: "success",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#169499",
              });
            })
            .catch((error) => {
              console.log(error.response.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "Erro de Conflito",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
        } else {
          CriancaService.putIrmao(
            idCrianca,
            valuesToSend,
            selectedFiliacao.pessoaFisicaIrmao.idPessoaFisica
          )
            .then((res) => {
              onClose();
              fetchIrmaosData();
              Swal.fire({
                title: "Sucesso!",
                text: "Registro atualizado com sucesso!",
                icon: "success",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#169499",
              });
            })
            .catch((error) => {
              console.log(error.response.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "Erro de Conflito",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
        }
      }

      actions.setSubmitting(false);
    }, 200);
  };

  const FocusErrorData = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const { dataNascimento, cpf } = values;
        const currentDate = new Date();

        if (dataNascimento) {
          const movementDate = parse(dataNascimento, "dd/MM/yyyy", new Date());
          if (isAfter(movementDate, currentDate)) {
            setDataFutura(true);
          } else {
            setDataFutura(false);
          }
        }
        if (cpf) {
          if (isValidCPF(cpf)) {
            setInvalidCPF(true);
            if (
              cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() !==
              selectedFiliacao?.pessoaFisicaIrmao?.cpf
                ?.replace(/[.-]|[.-](?=.)/g, "")
                .trim()
            ) {
              CriancaService.validaCPFCrianca(idCrianca, cpf)
                .then(() => setCriancaCPFValid(false))
                .catch((error) => {
                  console.log(error);
                  setCriancaCPFValid(true);
                });
            } else {
              setCriancaCPFValid(false);
            }
          } else {
            setInvalidCPF(false);
          }
        } else {
          setCriancaCPFValid(false);
        }
      };

      validateDate();
    }, [values, values.dataNascimento]);

    return null;
  };

  const clearEndereco = (props) => {
    props.setFieldValue("logradouro", "");
    props.setFieldValue("numeroResidencia", "");
    props.setFieldValue("complemento", "");
    props.setFieldValue("cep", "");
    props.setFieldValue("pontoReferencia", "");
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent
          p={{ base: "5px", sm: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            {isVisual
              ? "Visualizar Irmão".toUpperCase()
              : "Editar Irmão".toUpperCase()}
          </ModalHeader>
          <ModalBody
            p="0px"
            mt="25px"
            minH={{ base: "0px", md: "200px" }}
            pl="1px"
          >
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
              enableReinitialize
            >
              {(props) => (
                <Form style={{ width: "100%", paddingBottom: "5px" }}>
                  {setEditarIrmao(hasFormChanged(initialValues, props.values))}
                  <FocusError />
                  <FocusErrorData />
                  <Grid templateColumns="repeat(4, 1fr)" gap="15px" w="100%">
                    <GridItem colSpan={{ base: 4, lg: 3 }}>
                      <CustomInputWField
                        fieldName="nome"
                        label="Nome*"
                        placeholder="Informe o Nome"
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                        onChange={(e) =>
                          props.setFieldValue("nome", forNames(e.target.value))
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomDatepickerWField
                        fieldName="dataNascimento"
                        label="Data de Nascimento"
                        placeholder="DD/MM/AAAA"
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                        maxDate={new Date()}
                      />
                      {dataFutura && props.values.dataNascimento && (
                        <Text
                          mt="8px"
                          color="#E53E3E"
                          fontSize="sm"
                          lineHeight={"normal"}
                        >
                          A data informada não pode ser uma data futura!
                        </Text>
                      )}
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 2 }}>
                      <CustomMultiSelectWField
                        placeholderColor={"#1A202C"}
                        fieldName="filiacao"
                        label="Filiação em Comum*"
                        placeholder="Selecione a Filiação"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={opcoesFiliacao.isLoading}
                        options={opcoesFiliacao.options}
                        values={props?.values?.filiacao[0] || ""}
                        onChange={(value) => {
                          props.setFieldValue("filiacao", value ? value : "");
                        }}
                        onFocus={() => handleGetFiliacao(idCrianca)}
                        visible={true}
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                      />
                    </GridItem>
                    <GridItem colSpan={{ base: 4, lg: 2 }} />

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="cpf"
                        label="CPF"
                        placeholder="000.000.000-00"
                        maxLength={14}
                        onChange={(e) =>
                          props.setFieldValue(
                            "cpf",
                            e.target.value ? cpf(e.target.value) : ""
                          )
                        }
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                        setIsFocused={setIsFocused}
                        setIsBlur={
                          props?.values?.cpf?.replace(/[^\d]+/g, "").length ===
                            11 && setIsBlur
                        }
                      />
                      {props.values.cpf &&
                        !isFocused &&
                        !invalidCPF &&
                        !isBlur && (
                          <Text
                            color="red"
                            opacity={0.8}
                            mt={2}
                            fontSize="12px"
                          >
                            Informar um CPF válido
                          </Text>
                        )}
                      {props.values.cpf &&
                        !isFocused &&
                        criancaCPFValid &&
                        invalidCPF &&
                        !isBlur && (
                          <Text
                            color="red"
                            opacity={0.8}
                            mt={2}
                            fontSize="12px"
                          >
                            CPF já cadastrado nessa ficha.
                          </Text>
                        )}
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="numeroIdentidade"
                        label="Identidade"
                        placeholder="Informe a Identidade"
                        maxLength={15}
                        onChange={(e) =>
                          props.setFieldValue(
                            "numeroIdentidade",
                            onlyNumbers(e.target.value)
                          )
                        }
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="telefone"
                        label="Telefone"
                        placeholder="(99) 99999-9999"
                        maxLength={15}
                        onChange={(e) =>
                          props.setFieldValue(
                            "telefone",
                            telMask(e.target.value)
                          )
                        }
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                      />
                    </GridItem>
                    <GridItem colSpan={{ base: 4, lg: 1 }}>
                      <CustomInputWField
                        fieldName="email"
                        label="E-mail"
                        placeholder="Informe o e-mail"
                        maxLength={80}
                        onChange={(e) =>
                          props.setFieldValue(
                            "email",
                            e.target.value.toLowerCase()
                          )
                        }
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={4}>
                      <CustomTextArea
                        fieldName={"informacoesComplementares"}
                        label={"Informações Complementares"}
                        placeholder={"Informe as Informações Complementares"}
                        setIsTextareaFocused={setIsTextareaFocused}
                        maxLength={255}
                        isTextareaFocused={isTextareaFocused}
                        fontWeightLabel={500}
                        isDisabled={
                          isVisual || selectedFiliacao?.situacao === "Desligado"
                        }
                        colorLabel="#5F6377"
                        fontSizeLabel={"14px"}
                        lineHeightLabel={"19.6px"}
                      />
                    </GridItem>
                  </Grid>

                  <Divider mt="15px" />
                  <Text
                    color="#5F6377"
                    fontWeight={500}
                    fontSize="14px"
                    lineHeight="19.6px"
                    mt="15px"
                  >
                    Endereço
                  </Text>

                  <Grid
                    templateColumns="repeat(9, 1fr)"
                    gap="15px"
                    mt="15px"
                    w="100%"
                  >
                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idEstado"
                        label="Estado"
                        placeholder="Selecione o Estado"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={estados.isLoading}
                        options={estados.options}
                        onChange={(value) => {
                          if (value && props.values.idEstado) {
                            if (value.nome !== props.values.idEstado.nome) {
                              props.setFieldValue("idMunicipio", "");
                              props.setFieldValue("idBairro", "");
                            }
                          } else {
                            props.setFieldValue("idMunicipio", "");
                            props.setFieldValue("idBairro", "");
                          }
                          setEstado(value);
                          setMunicipio(false);
                          props.setFieldValue("idEstado", value);
                          clearEndereco(props);
                        }}
                        onFocus={
                          estados.options.length === 0 ? handleGetEstados : null
                        }
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idMunicipio"
                        label="Cidade"
                        placeholder="Selecione a Cidade"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={municipios.isLoading}
                        options={municipios.options}
                        onChange={(value) => {
                          setMunicipio(value);
                          props.setFieldValue("idMunicipio", value);
                          props.setFieldValue("idBairro", "");
                          clearEndereco(props);
                        }}
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 3 }}>
                      <CustomSelectWField
                        fieldName="idBairro"
                        label={`Bairro${
                          props?.values?.idMunicipio?.id === 3233 ||
                          props?.values?.idMunicipio?.id === 3215
                            ? "*"
                            : ""
                        }`}
                        placeholder="Selecione o Bairro"
                        getOptionLabel={(option) => option.nome}
                        getOptionValue={(option) => option.id}
                        isLoading={bairros.isLoading}
                        options={bairros.options}
                        onChange={(value) => {
                          props.setFieldValue("idBairro", value);
                          !value && clearEndereco(props);
                        }}
                        isDisabled={isVisual}
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 7 }}>
                      <CustomInputWField
                        fieldName="logradouro"
                        label="Logradouro"
                        placeholder="Informe o Logradouro"
                        maxLength={80}
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 2 }}>
                      <CustomInputWField
                        fieldName="numeroResidencia"
                        label="Número"
                        placeholder="Informe o Número"
                        maxLength={14}
                        onChange={(e) =>
                          props.setFieldValue(
                            "numeroResidencia",
                            numeroEndereco(e.target.value)
                          )
                        }
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 7 }}>
                      <CustomInputWField
                        fieldName="complemento"
                        label="Complemento"
                        placeholder="Informe o Complemento"
                        maxLength={255}
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 2 }}>
                      <CustomInputWField
                        fieldName="cep"
                        label="CEP"
                        placeholder="Informe o CEP"
                        maxLength={9}
                        onChange={(e) =>
                          props.setFieldValue("cep", cepMask(e.target.value))
                        }
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>

                    <GridItem colSpan={{ base: 9, lg: 9 }}>
                      <CustomInputWField
                        fieldName="pontoReferencia"
                        label="Ponto de Referência"
                        placeholder="Informe o Ponto de Referência"
                        maxLength={2000}
                        isDisabled={
                          isVisual ||
                          !props.values.idEstado ||
                          !props.values.idMunicipio ||
                          !props.values.idBairro
                        }
                      />
                    </GridItem>
                  </Grid>

                  <Flex justifyContent="end">
                    <SimpleGrid
                      mt="25px"
                      columns={
                        isVisual &&
                        (selectedFiliacao?.situacao ===
                          "Sem histórico de acolhimento" ||
                          selectedFiliacao?.situacao === "Desligado")
                          ? 2
                          : !isVisual
                          ? 2
                          : 1
                      }
                      spacing="15px"
                      w={{
                        base: "100%",
                        lg:
                          isVisual &&
                          (selectedFiliacao.situacao ===
                            "Sem histórico de acolhimento" ||
                            selectedFiliacao?.situacao === "Desligado")
                            ? "40%"
                            : !isVisual
                            ? "40%"
                            : "20%",
                      }}
                    >
                      {isVisual ? (
                        <CustomButton onClick={onClose} label="Voltar" />
                      ) : (
                        <CustomButton onClick={backAlert} label="Cancelar" />
                      )}

                      {isVisual ? (
                        <Permission
                          roleKeycloack={roleKeycloack}
                          func={referenciaFunc.irmaoAlterar}
                          id={idPJ}
                          user={user}
                          visualizar={true}
                        >
                          {selectedFiliacao?.situacao ===
                            "Sem histórico de acolhimento" ||
                          selectedFiliacao?.situacao === "Desligado" ? (
                            <CustomButton
                              onClick={(e) => {
                                e.preventDefault();
                                setIsVisual(false);
                              }}
                              label="Editar"
                            />
                          ) : (
                            ""
                          )}
                        </Permission>
                      ) : (
                        <CustomButton
                          type="submit"
                          translate="no"
                          isLoading={props.isSubmitting}
                          label="Confirmar"
                        />
                      )}
                    </SimpleGrid>
                  </Flex>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
